module.exports = __webpack_public_path__ + "img/ic-linkedin.b31935df.svg";